import PropTypes from 'prop-types';
import Translation from '../../../lang/Translation';
import DetailedTooltip from '../DetailedTooltip';

export function PayerNameTooltip(props) {
  return (
    <DetailedTooltip title="" tooltipID={props.tooltipID}>
      <Translation>payer.name.tooltip.advice</Translation>
    </DetailedTooltip>
  );
}

PayerNameTooltip.propTypes = {
  tooltipID: PropTypes.string.isRequired,
};

export default PayerNameTooltip;
